import React from "react";
import RingotelUserForm from "../Form/RingotelUser";
import { RingotelUser } from "../../hooks/apis/ringotelUsers.api";
import ModalWrapper from "../generic/modal";
const EditRingtelUserModal = ({
  setIsModalOpen,
  isModalOpen,
  editData,
}: {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isModalOpen: boolean;
  editData: RingotelUser | null;
}) => {
  return (
    <ModalWrapper
      title="Edit Ringotel User"
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
    >
      <RingotelUserForm  editData={editData} setIsModal={setIsModalOpen} />
    </ModalWrapper>
  );
};

export default EditRingtelUserModal;
